import { Routes } from '@angular/router';
import { checkoutGuard } from './core/guards/checkout.guard';
import { adminGuard } from './core/guards/admin.guard';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/landing/landing').then(m => m.Landing)
  },

  {
    path: 'our-brands',
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'services' },
      { path: 'bwell', loadComponent: () => import('./pages/b-well/be-well').then(m => m.BeWell) },
      { path: 'breathepure', loadComponent: () => import('./pages/breathe-pure/breathe-pure').then(m => m.BreathePure) },
      { path: 'wellgro', loadComponent: () => import('./pages/well-grow/well-gro').then(m => m.WellGro) },
      { path: 'wellpro', loadComponent: () => import('./pages/well-pro/well-pro').then(m => m.WellPro) },
    ]
  },

//   {
//     path: 'wellpro',
//     loadComponent: () => import('./pages/wellpro/wellpro.component').then(m => m.WellproComponent),
//     children: [
//       { path: '', pathMatch: 'full', redirectTo: 'services' },
//       { path: 'services', loadComponent: () => import('./pages/wellpro/services.component').then(m => m.WellproServicesComponent) },
//       { path: 'products', loadComponent: () => import('./pages/wellpro/products.component').then(m => m.WellproProductsComponent) }
//     ]
//   },

  // {
  //   path: 'breathe-pure',
  //   children: [
  //     { path: '', pathMatch: 'full', redirectTo: 'services' },
  //     { path: 'services', loadComponent: () => import('./pages/breathe-pure/our-services/our-services').then(m => m.OurServices) },
  //     { path: 'products', loadComponent: () => import('./pages/breathe-pure/products/products').then(m => m.Products) }
  //   ]
  // },

//   {
//     path: 'bewell',
//     loadComponent: () => import('./pages/bewell/bewell.component').then(m => m.BewellComponent),
//     children: [
//       { path: '', pathMatch: 'full', redirectTo: 'services' },
//       { path: 'services', loadComponent: () => import('./pages/bewell/services.component').then(m => m.BewellServicesComponent) },
//       { path: 'products', loadComponent: () => import('./pages/bewell/products.component').then(m => m.BewellProductsComponent) }
//     ]
//   },

//   {
//     path: 'about',
//     loadComponent: () => import('./pages/about/about').then(m => m.About)
//   },
{
    path: 'skill-development',
    loadComponent: () => import('./pages/skill-development/skill-development').then(m => m.SkillDevelopment)
  },
{
    path: 'about',
    loadComponent: () => import('./pages/about-us/about-us').then(m => m.AboutUs)
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact-us/contact-us').then(m => m.ContactUs)
  },
  {
    path: 'products',
    loadComponent: () => import('./pages/products/products').then(m => m.Products)
  },
  {
    path: 'products/:sku',
    loadComponent: () => import('./pages/product-detail/product-detail').then(m => m.ProductDetail)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then(m => m.Login)
  },
  // /register was merged into /login (2026-08-31) — with only Google/Mobile as methods, Firebase
  // already treats both as "create or sign in", so there was no real second workflow. Kept as a
  // redirect for any bookmarks/links still pointing at the old URL.
  { path: 'register', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password').then(m => m.ForgotPassword)
  },
  {
    path: 'logged-out',
    loadComponent: () => import('./pages/logged-out/logged-out').then(m => m.LoggedOut)
  },
  {
    path: 'checkout',
    canActivate: [checkoutGuard],
    loadComponent: () => import('./pages/checkout/checkout').then(m => m.Checkout)
  },
  {
    path: 'admin/login',
    loadComponent: () => import('./pages/admin/admin-login').then(m => m.AdminLogin)
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadComponent: () => import('./pages/admin/admin-layout').then(m => m.AdminLayout),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', data: { title: 'Dashboard' }, loadComponent: () => import('./shared/components/coming-soon/coming-soon').then(m => m.ComingSoon) },
      { path: 'products', data: { title: 'Manage Products' }, loadComponent: () => import('./pages/admin/admin-products/admin-products').then(m => m.AdminProducts) },
      { path: 'products/new', data: { title: 'Add Product' }, loadComponent: () => import('./pages/admin/admin-product-form/admin-product-form').then(m => m.AdminProductForm) },
      { path: 'products/:sku/edit', data: { title: 'Edit Product' }, loadComponent: () => import('./pages/admin/admin-product-form/admin-product-form').then(m => m.AdminProductForm) },
      { path: 'reports', data: { title: 'Reports' }, loadComponent: () => import('./shared/components/coming-soon/coming-soon').then(m => m.ComingSoon) },
    ]
  },
  {
    path: 'business',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/business/business-layout').then(m => m.BusinessLayout),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', loadComponent: () => import('./pages/business/business-dashboard').then(m => m.BusinessDashboard) },
      { path: 'products', data: { title: 'Products' }, loadComponent: () => import('./shared/components/coming-soon/coming-soon').then(m => m.ComingSoon) },
      { path: 'quotation', data: { title: 'Quotation' }, loadComponent: () => import('./shared/components/coming-soon/coming-soon').then(m => m.ComingSoon) },
    ]
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/profile/profile').then(m => m.Profile)
  },

  { path: '**', redirectTo: '', pathMatch: 'full' }
];